import SportIcons from './_sport-icons.js'
import BaseEventCard from './_base-event-card.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import AbsolutePane from './_absolute-pane.js'
import Image from './_image.js'

export default {
  name: 'FallbackEventCard',
  values: {
    showBackgroundSportImage: true,
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    eventCardBase: {
      configSet: BaseEventCard,
      configValues: {
        container: {
          createStackingContext: true,
          style: {
            padding: '8px 8px 0',
          },
        },
        clickableArea: {
          style: {
            base: {
              flexBasis: '50px',
              justifyContent: 'flex-start',
            },
          },
        },
      },
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          width: '206px',
          minHeight: '53px',
          padding: '16px 0',
        },
      },
    },
    contentText: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 4,
      },
    },
    backgroundImageContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '106px',
          height: '91px',
          top: '8px',
          right: '8px',
          overflow: 'hidden',
        },
      },
    },
    backgroundImage: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '120px',
          minHeight: '120px',
          alignSelf: 'flex-end',
          padding: '0 0 8px 8px',
        },
      },
    },
    betNowContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '12px 0',
          alignItems: 'baseline',
          justifyContent: 'flex-end',
        },
      },
    },
    betNowText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: '0',
          padding: '0 4px',
        },
      },
    },
    betNowIcon: {
      configSet: Image,
      configValues: {
        src: 'chevron-right',
        style: {
          minWidth: '8px',
          minHeight: '8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
